export const currentAdminSelector = (state: any) => state.currentAdmin;
